import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { formatApiError, loginWithUsername } from '../../api/auth';
import './Login.css';

const Login = () => {
  const { t } = useTranslation();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isVerifying, setIsVerifying] = useState(false);
  const [apiError, setApiError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setApiError('');
    setIsVerifying(true);
    try {
      await loginWithUsername(username, password);
      navigate('/');
    } catch (err) {
      const msg = formatApiError(err.response?.data) || err.message || t('login.failed');
      setApiError(msg);
    } finally {
      setIsVerifying(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">AuraGlow</div>
        <h1 className="login-title">{t('login.title')}</h1>
        <p className="login-subtitle">{t('login.subtitle')}</p>

        <form className="login-form" onSubmit={handleSubmit}>
          <label className="login-label">
            <span className="login-label-text">
              {t('login.username')}<span className="required">*</span>
            </span>
            <input
              type="text"
              className="login-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="your_username"
              required
              autoComplete="username"
            />
          </label>

          <label className="login-label">
            <span className="login-label-text">
              {t('login.password')}<span className="required">*</span>
            </span>
            <div className="login-password-wrap">
              <input
                type="password"
                className="login-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder={t('login.placeholder')}
                required
                autoComplete="current-password"
              />
              <button type="button" className="password-toggle" aria-label="Toggle password visibility">
                👁
              </button>
            </div>
          </label>

          {isVerifying && (
            <div className="login-verifying">
              <span className="spinner" aria-hidden="true" />
              <span>{t('login.verifying')}</span>
            </div>
          )}

          {apiError ? (
            <p className="register-form-error" role="alert">
              {apiError}
            </p>
          ) : null}

          <div className="login-links-row">
            <button type="button" className="login-link-btn">
              {t('login.forgot')}
            </button>
          </div>

          <button type="submit" className="login-submit-btn" disabled={isVerifying}>
            {t('login.continue')}
          </button>

          <p className="login-footer-text">
            {t('login.noAccount')}{' '}
            <button type="button" className="login-link-btn" onClick={() => navigate('/register')}>
              {t('login.signUp')}
            </button>
          </p>
        </form>
      </div>
    </div>
  );
};

export default Login;
